import { ElectronicTradingWidgetProps } from '@cian/frontend-electronic-trading-widget';
import { Button, ModalWindow } from '@cian/ui-kit';
import * as React from 'react';

import { ElectronicTradingWidgetLoadable } from '../ElectronicTradingWidgetLoadable';
import { ElectronicTradingWidgetLoadableFallback } from '../ElectronicTradingWidgetLoadableFallback';

const MODAL_WIDTHS = {
  narrow: 498,
  wide: 680,
};

type JoinElectronicTradingButtonProps = ElectronicTradingWidgetProps & {
  loading?: boolean;
  open: boolean;
  onButtonClick: VoidFunction;
  onClose: VoidFunction;
};

export const JoinElectronicTradingButton: React.FC<JoinElectronicTradingButtonProps> = props => {
  const { loading, open, onButtonClick, onClose, ...widgetProps } = props;

  return (
    <>
      {open && (
        <ModalWindow
          fixed
          content={
            <ElectronicTradingWidgetLoadable fallback={<ElectronicTradingWidgetLoadableFallback />}>
              {(Lib): React.JSX.Element => <Lib.ElectronicTradingWidget {...widgetProps} />}
            </ElectronicTradingWidgetLoadable>
          }
          open
          size="M"
          title="Переходим к электронным торгам"
          width={widgetProps.publisherPhoneNumbers.length ? MODAL_WIDTHS.wide : MODAL_WIDTHS.narrow}
          onClose={onClose}
        />
      )}
      <Button
        fullWidth
        data-testid="electronic-trading.join-trading"
        loading={loading}
        size="XS"
        theme="fill_primary"
        onClick={onButtonClick}
      >
        Принять участие в торгах
      </Button>
    </>
  );
};
